import {Link as RouterLink} from 'react-router-dom';
import styled from 'styled-components';

import {colors} from 'theme';

export const Link = styled(RouterLink)`
    color: ${colors.brandPrimary};
    text-decoration: none;

    :hover {
        color: ${colors.brandDark};
    }
`;
